import type { RootState } from '../types';

export const selectTransferMethod = (state: RootState) => state.transferMethod;
